export function compareDecimalStrings(str1, str2) {
  const num1 = Math.round(parseFloat(str1) * 100) / 100;
  const num2 = Math.round(parseFloat(str2) * 100) / 100;
  return num1 === num2;
}
